/**
 * Normalizes participant-entered access codes to match Laravel's PACILO format.
 * Plaintext codes use an uppercase non-ambiguous alphabet (PACILO-XXXX-XXXX-XXXX).
 */
export function normalizeAccessCode(value) {
  return String(value || '').trim().toUpperCase();
}

/**
 * Maps an inspect response to safe, user-facing preview fields only.
 */
export function mapAccessCodeInspectPreview(data = {}) {
  const nextAction = data.next_action === 'resume' ? 'resume' : 'start';
  return {
    companyName: data.company_name
      || data.company?.display_name
      || data.company?.name
      || '',
    nextAction,
    expiresAt: data.expires_at || data.expiration_at || data.valid_until || null,
    consent: data.consent && typeof data.consent === 'object' ? data.consent : {},
    grants: data.grants || null,
  };
}

/**
 * Resolves the assessment attempt identity from a redeem response.
 * Never uses access_code_id — that identifies the code record, not the attempt.
 */
export function resolveRedeemAttemptId(response = {}) {
  const attemptId = response.attempt?.id ?? response.attempt_id ?? null;
  if (attemptId == null || attemptId === '') {
    return null;
  }
  return attemptId;
}

/**
 * Resolves whether redemption starts a new attempt or resumes an existing one.
 */
export function resolveRedeemNextAction(response = {}, preview = null) {
  if (response.next_action === 'resume' || response.next_action === 'start') {
    return response.next_action;
  }
  if (preview?.nextAction === 'resume' || preview?.nextAction === 'start') {
    return preview.nextAction;
  }
  if (response.attempt?.status === 'in_progress') {
    return 'resume';
  }
  return 'start';
}
